:root {
  /* Tweak these to fit your theme */
  --bis-border: #e5e7eb; /* neutral-200 */
  --bis-border-hover: #cfd2d8; /* neutral-300 */
  --bis-bg: #ffffff;
  --bis-bg-selected: #ffffff;
  --bis-ring: #111827; /* neutral-900 */
  --bis-text: #111827;
  --bis-text-muted: #6b7280; /* neutral-500 */
  --bis-disabled: #9ca3af; /* neutral-400 */
  --bis-shadow: 0 1px 2px rgba(0, 0, 0, 0.06), 0 1px 1px rgba(0, 0, 0, 0.04);
}

.container {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding: 4px;
  scroll-behavior: smooth;
}

.container::-webkit-scrollbar {
  height: 6px;
}

.container::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.12);
  border-radius: 9999px;
}

.row {
  display: flex;
  gap: 10px;
  align-items: stretch;
  min-height: auto;
}

.item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0;

  height: 108px;
  width: 65px;

  padding: 0;

  background: var(--bis-bg);
  border: 1.5px solid var(--bis-border);
  border-radius: 20px;
  corner-shape: superellipse(1.18);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

  color: var(--bis-text);
  cursor: pointer;
  outline: none;

  transition:
    border-color 150ms ease,
    box-shadow 150ms ease,
    transform 100ms ease,
    background-color 150ms ease;
}

.item:hover:not(.selected) {
  border-color: var(--bis-border-hover);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  transform: translateY(-1px);
}

.item:focus-visible {
  box-shadow:
    0 0 0 2px #fff,
    0 0 0 4px var(--bis-ring);
}

.selected {
  border-color: var(--bis-ring);
  border-width: 1px;
  background: var(--bis-bg-selected);
  box-shadow: 0 2px 8px rgba(17, 24, 39, 0.12);
}

.disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.content {
  display: grid;
  place-items: center;
  width: 54px;
  height: 90px;
  flex-shrink: 0;
}

.content img {
  width: 45px;
  height: 60px;
  object-fit: contain;
  display: block;
}

.label {
  display: none;
}

.checkmark {
  position: absolute;
  top: 4px;
  right: 4px;
  height: 20px;
  width: 20px;
  border-radius: 9999px;
  color: #505050;
  font-weight: 400;
  font-size: 13px;
  display: grid;
  place-items: center;
}
